export const TENDER_DEFAULT_USER_ID = 2;
export const COM_DEFAULT_USER_ID = 3;
export const LAB_DEFAULT_USER_ID = 4;

